import {getSignedStorageUrl} from '../../api/gallery/getSignedStorageUrl';
import {uploadFileToAwsS3} from '../../api/gallery/uploadFileToAwsS3';

export async function uploadDataToAws(data) {
  const file = new Blob([JSON.stringify(data)], {type: 'text/plain'});
  const {headers, url, key} = await getSignedStorageUrl();
  await uploadFileToAwsS3(url, file, headers);
  return key;
}
